import { createHttpContextFromOptions } from '@quipex/core/primitives';
import type { BuildingsApiService } from '@quipex/shared/contracts';
import { firstValueFrom, map } from 'rxjs';

export function deleteDraftBuilding(
    buildingsApi: BuildingsApiService,
    buildingId: string
): Promise<void> {
    const context = createHttpContextFromOptions({
        // The delete confirmation workflow maps failures to building-specific retry copy.
        suppressAutoErrorToast: true,
    });

    return firstValueFrom(
        buildingsApi
            .removeBuilding(buildingId, { context })
            .pipe(map(() => undefined))
    );
}
